/**
 * Utility per gestire URL autenticati dei file
 */

export const getAuthenticatedFileUrl = (fileUrl) => {
  if (!fileUrl) return '';
  if (typeof fileUrl !== 'string') return '';
  if (fileUrl.startsWith('http')) return fileUrl; // External URL
  
  const token = localStorage.getItem('token');
  if (!token) return `${process.env.REACT_APP_BACKEND_URL}${fileUrl}`;
  
  const baseUrl = `${process.env.REACT_APP_BACKEND_URL}${fileUrl}`;
  
  // Add token as query parameter
  return `${baseUrl}?token=${encodeURIComponent(token)}`;
};
